import LayoutCentered from '@/layout/LayoutCentered';

export default [
  {
    path: '/settings',
    component: LayoutCentered,
    meta: {
      auth: true,
      requirePermission: 'admin',
    },
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import('@/components/pages/settings/Settings'),
      },
    ],
  },
];
